"use strict";
// tslint:disable
/*  UBT数据头定义为app.project[.scene.ab.theme]-page[.element]。
    中括号中的字段可选，但是要注意，如果需要设置后面的字段，前面的字段也必须保留，统一使用默认值0。例如wk.opu2.0.a，scene是不需要，但是因为ab存在，所以要设置为默认值0。
    各个字段说明如下：
    "wk.opu02.a.a-home.rec_list_x"
    app：站点标识，为了和玄武的保持一致，内置微课H5为wk，蒲公英位pgy，微课APP为wka。
    project：项目名，运营活动统一以opu开头，例如opu2。
    scene：入口场景值，用来标识用户从哪里进来。
    ab：A/B测试标识，统一使用字母表示。
    theme：皮肤主题标识。
    page：页面标识，最好有明确语义
    element：控件标识，最好有明确语义

    运营打点文档记录
    https://gitlab.weike.fm/oc/oc-docs/blob/master/records/%E8%BF%90%E8%90%A5%E6%B4%BB%E5%8A%A8%E5%9F%8B%E7%82%B9%E5%8D%8F%E8%AE%AE.md
*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hotSpotServer = exports.WrapChannelReport = exports.reportClickEvent = exports.reportViewEvent = exports.reportServer = exports.reAssemblyUbt = exports.isFromOutSide = exports.hijack = exports.getUbt = exports.setUbtInit = exports.initSpm = exports.Config = exports.EventType = void 0;
var request_1 = require("../../utils/request");
var tools_1 = require("../../utils/tools");
var EventType;
(function (EventType) {
    EventType["impress"] = "impress";
    EventType["click"] = "click";
    EventType["view"] = "view";
})(EventType = exports.EventType || (exports.EventType = {}));
exports.Config = {
    platform: 'wk',
};
exports.initSpm = '';
function setUbtInit(project, page) {
    exports.initSpm = exports.Config.platform + "." + project + ".@replaceSceen-" + page;
}
exports.setUbtInit = setUbtInit;
function getUbt() {
    return exports.initSpm;
}
exports.getUbt = getUbt;
exports.hijack = 'hijack';
function isFromOutSide() {
    return window.location.href.indexOf('outside_site') > -1;
}
exports.isFromOutSide = isFromOutSide;
function reAssemblyUbt(element, scene) {
    if (isFromOutSide()) {
        return exports.initSpm.replace('.@replaceSceen', "." + exports.hijack) + "." + element;
    }
    if (scene || window.location.href.indexOf('scene') > -1) {
        var _scene = scene;
        if (!scene) {
            _scene = tools_1.getJsonFromUrl().scene;
        }
        return exports.initSpm.replace('.@replaceSceen', "." + _scene) + "." + element;
    }
    else {
        return exports.initSpm.replace('.@replaceSceen', '') + "." + element;
    }
}
exports.reAssemblyUbt = reAssemblyUbt;
exports.reportServer = {
    reportServerAPI: function (param) {
        var request = new request_1.Request(tools_1.isTest() ? 'http://106.52.219.91:8846' : 'https://collector.lizhiweike.com');
        request.$post("/api/data_collector/logs", { data: param }, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
    },
};
/**
 * 页面访问
 * @param element  RegisterElement 上面注册的elment
 * @param evt_params  参数，可选
 */
exports.reportViewEvent = function (element, evt_params, scene) {
    if (evt_params === void 0) { evt_params = {}; }
    var ubt = reAssemblyUbt(element, scene);
    if (isFromOutSide()) {
        ubt = reAssemblyUbt(element, exports.hijack);
    }
    try {
        exports.reportServer.reportServerAPI([
            {
                ubt: ubt,
                evt: EventType['view'],
                evt_params: evt_params,
            },
        ]);
    }
    catch (err) {
        console.log(err);
    }
};
/**
 *
 * @param element  RegisterElement 上面注册的elment
 * @param evt_params  参数，可选
 */
exports.reportClickEvent = function (element, evt_params, scene) {
    if (evt_params === void 0) { evt_params = {}; }
    var ubt = reAssemblyUbt(element, scene);
    if (isFromOutSide()) {
        ubt = reAssemblyUbt(element, exports.hijack);
    }
    try {
        exports.reportServer.reportServerAPI([
            {
                ubt: ubt,
                evt: EventType['click'],
                evt_params: evt_params,
            },
        ]);
    }
    catch (err) {
        console.log(err);
    }
};
exports.WrapChannelReport = function (eventSingle) {
    try {
        var len = eventSingle.length;
        var resultArray = [];
        for (var i = 0; i < len; i++) {
            resultArray.push({
                ubt: "" + eventSingle[i].ubt,
                evt: EventType['impress'],
                evt_params: eventSingle[i].params,
            });
        }
        exports.reportServer.reportServerAPI(resultArray);
    }
    catch (err) {
        console.log(err);
    }
};
exports.hotSpotServer = {
    hotSpotLogs: function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    exports.WrapChannelReport(data);
                }
                catch (error) {
                    console.log(error);
                }
                return [2 /*return*/];
            });
        });
    },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@weike/operation-report/dist/components/HotSpot/service.js
// module id = 198
// module chunks = 0